// 报警记录
import httpRequest from '@/utils/request.js';

// 报警触发开关日志
export const getLogPage = params =>
    httpRequest.httpGet({
        url: '/service/alarmSwitchLog/page',
        params
    });

// 获取报警触发开关日志详情
export const getLogDetail = id =>
    httpRequest.httpGet({
        url: '/service/alarmSwitchLog/detail',
        params: {
            id
        }
    });

// 修改报警日志
export const updateAlarmLog = params => httpRequest.httpPut('/service/alarmSwitchLog/update', params);

// 删除报警触发开关日志
export const delAlarmSwitchLog = ids => httpRequest.httpdelete2('/service/alarmSwitchLog/delete', ids);
